import { capitalize } from "lodash";
import React from "react";

import GenericPullConfigListing from "../GenericPullConfigListing";
import AxoniusCredentialsForm from "./AxoniusCredentialsForm";
import AxoniusMappingForm from "./AxoniusMappingForm";

const ASSET_TYPE_LABELS = {
  devices: "Devices",
  domainsAndUrls: "Domains & URLs",
};

const AxoniusConfigListing = (props) => {
  const columns = [
    {
      title: "Asset Types",
      dataIndex: "assetType",
      width: 200,
      render: (value) => ASSET_TYPE_LABELS[value] || capitalize,
    },
  ];

  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={AxoniusMappingForm}
      extraColumns={columns}
      CredentialsForm={AxoniusCredentialsForm}
    />
  );
};

export default AxoniusConfigListing;
